module.exports = __webpack_public_path__ + "static/img/zxxfdb.44f006f9.png";